module.exports = __webpack_public_path__ + "img/graypin.097c64b1.svg";